import React from 'react';
import { Transfer } from '../../types/Quotation';

interface TransferCardProps {
  transfer: Transfer & { day: number };
}

const TransferCard: React.FC<TransferCardProps> = ({ transfer }) => {
  const getVehicleIcon = (vehicle?: string) => {
    if (!vehicle) return '🚗';
    const vehicleLower = vehicle.toLowerCase();
    if (vehicleLower.includes('bus') || vehicleLower.includes('coach')) return '🚌';
    if (vehicleLower.includes('van') || vehicleLower.includes('minivan')) return '🚐';
    if (vehicleLower.includes('suv')) return '🚙';
    if (vehicleLower.includes('limo') || vehicleLower.includes('luxury')) return '🚗';
    if (vehicleLower.includes('taxi') || vehicleLower.includes('cab')) return '🚕';
    if (vehicleLower.includes('train')) return '🚆';
    if (vehicleLower.includes('boat') || vehicleLower.includes('ferry')) return '⛴️';
    return '🚗';
  };

  const getTransferType = () => {
    if (transfer.pickupFromAirport) {
      return { type: 'Airport to Hotel', icon: '', color: '#3498db' };
    } else {
      return { type: 'Hotel to Airport', icon: '', color: '#e74c3c' };
    }
  };

  const transferType = getTransferType();

  return (
    <div style={{
      border: '1px solid #e1e5e9',
      borderRadius: '12px',
      padding: '16px',
      marginBottom: '16px',
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      gap: '16px'
    }}>
      {/* Vehicle Icon */}
      <div style={{ flex: '0 0 80px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          marginBottom: '8px',
          border: '2px solid #e9ecef'
        }}>
          {getVehicleIcon(transfer.vehicle)}
        </div>
        <div style={{
          fontSize: '10px',
          color: '#6c757d',
          textAlign: 'center',
          lineHeight: '1.2'
        }}>
          {transfer.vehicle || 'Standard Vehicle'}
        </div>
      </div>

      {/* Transfer Details */}
      <div style={{ flex: 1 }}>
        {/* Header */}
        <div style={{ marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <span style={{ fontSize: '16px' }}>{transferType.icon}</span>
            <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              {transfer.name || 'Transfer Service'}
            </h4>
            <span style={{
              fontSize: '11px',
              backgroundColor: transferType.color,
              color: 'white',
              padding: '2px 6px',
              borderRadius: '8px',
              fontWeight: '500'
            }}>
              {transferType.type}
            </span>
          </div>
        </div>

        {/* Route Information */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: '12px'
        }}>
          {/* From */}
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              {transfer.pickupFromAirport 
                ? (transfer.airportName || transfer.airportCode || 'Airport')
                : (transfer.hotelName || transfer.hotelCode || 'Hotel')
              }
            </div>
            <div style={{ fontSize: '12px', color: '#6c757d' }}>
              {transfer.pickupFromAirport ? 'Airport' : 'Hotel'}
            </div>
          </div>

          {/* Arrow */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            flex: '0 0 80px',
            padding: '0 16px'
          }}>
            <div style={{
              width: '100%',
              height: '2px',
              backgroundColor: '#bdc3c7',
              position: 'relative',
              marginBottom: '8px'
            }}>
              <div style={{
                position: 'absolute',
                right: '0',
                top: '-4px',
                width: '0',
                height: '0',
                borderLeft: '8px solid #bdc3c7',
                borderTop: '4px solid transparent',
                borderBottom: '4px solid transparent'
              }} />
            </div>
            <div style={{ 
              fontSize: '12px', 
              color: '#6c757d',
              textAlign: 'center'
            }}>
              Transfer
            </div>
          </div>

          {/* To */}
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              {transfer.pickupFromAirport 
                ? (transfer.hotelName || transfer.hotelCode || 'Hotel')
                : (transfer.airportName || transfer.airportCode || 'Airport')
              }
            </div>
            <div style={{ fontSize: '12px', color: '#6c757d' }}>
              {transfer.pickupFromAirport ? 'Hotel' : 'Airport'}
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: '12px',
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px'
        }}>
          <div>
            <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px' }}>Pickup Date</div>
            <div style={{ fontSize: '12px', fontWeight: '500' }}>
              {transfer.pickupDate || 'TBD'}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '10px', color: '#6c757d', marginBottom: '2px' }}>Pickup Time</div>
            <div style={{ fontSize: '12px', fontWeight: '500' }}>
              {transfer.pickupTime || 'TBD'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferCard;
